// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { tablet16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { IconSvg, registerIconSvg } from '../../icon-svg';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-tablet': IconTablet;
    }
}

/**
 * The icon component for the 'tablet' icon
 */
export class IconTablet extends IconSvg {
    public constructor() {
        super(tablet16X16);
    }
}

registerIconSvg('icon-tablet', IconTablet);
export const iconTabletTag = 'nimble-icon-tablet';
